import React from 'react';

import { Router, Route, Switch, Redirect } from 'react-router';
import PrivateRoute from './utils/privateRoute';
import { history } from './store/store';

import CookiePolicy from './pages/cookie-policy/CookiePolicy';
import Home from './pages/home/home';
import { useSelector } from 'react-redux';
import { GuestHome } from 'pages/guest/GuestHome';
import NoAccessMessage from 'pages/login/NoAccessMessage';
import SigninCallback from 'pages/login/callback';
import AuthService from 'services/authService';
import {SelectedAccountProvider} from "./pages/home/teams/components/account-dropdown/SelectedAccountContext";


/**
 * For storing internal page redirection inside application
 */
export const Routes = () => {
     let isLoggedIn = useSelector((state: any) => state.auth?.user?.access_token? true: false);
     return (

         <SelectedAccountProvider>
          <Router history={history} >
               <Switch>
                    <Route exact path="/cookie-policy" component={CookiePolicy} />
                    <Route exact path="/callback" component={SigninCallback} />
                    <PrivateRoute path="/home" component={Home}  />
                    <Route path="/guest" render={() => (<GuestHome/>)} />
                    <Route path="/noaccess" component={NoAccessMessage} />

                    <Route path="*"  render={()=>{
                         return(
                         <Redirect to ={"/home"} />
                         );
                    }}/>
               </Switch>
          </Router>
         </SelectedAccountProvider>
     );
};
